import * as React from 'react';
import Svg, {Defs, LinearGradient, Path, Stop} from 'react-native-svg';

type GrpReferralRedesignIconProps = {
  width: number;
  height: number;
};

const GrpReferralRefive = (props?: GrpReferralRedesignIconProps) => (
  <Svg
    width={props.width ?? 101}
    height={props.height ?? 100}
    viewBox="0 0 101 100"
    fill="none"
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M75.885 63.43c-5.937 0-10.75 4.813-10.75 10.75 0 1.127.172 2.208.492 3.225l-2.93.922a13.88 13.88 0 01-.634-4.147c0-7.633 6.189-13.82 13.82-13.82 2.715 0 5.249.783 7.385 2.137l1.83-1.83 1.229 1.228v5.528h-5.529l-1.228-1.228 1.457-1.457a10.698 10.698 0 00-5.144-1.306l.002-.002zm10.75 10.75c0-1.127-.172-2.208-.492-3.225l2.93-.922c.42 1.342.634 2.74.634 4.147 0 7.633-6.189 13.82-13.82 13.82-2.715 0-5.249-.783-7.385-2.137l-1.83 1.83-1.229-1.228v-5.528h5.529l1.228 1.228-1.457 1.457a10.7 10.7 0 005.144 1.306c5.936 0 10.75-4.813 10.75-10.75l-.002.002zm-12.592-5.528h.615v-1.844h2.457v1.844h.615c1.357 0 2.457 1.1 2.457 2.456v.615H77.73v-.615h-3.685v1.144l4.167.833a2.456 2.456 0 011.975 2.408v1.759c0 1.356-1.1 2.456-2.457 2.456h-.615v1.844h-2.457v-1.844h-.615a2.457 2.457 0 01-2.456-2.456v-.615h2.456v.615h3.685v-1.757l-4.166-.833a2.456 2.456 0 01-1.975-2.409V71.11c0-1.357 1.1-2.457 2.456-2.457v-.001z"
      fill="url(#paint0_linear_14209_45184)"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.602 13.122c-10.308 0-18.665 8.356-18.665 18.665 0 10.308 8.357 18.665 18.665 18.665s18.665-8.357 18.665-18.665c0-10.309-8.357-18.665-18.665-18.665zm-2.247 41.021c-13.026 0-25.275 3.317-35.908 9.14L11.394 64.4v18.232H59.4l-.653-5.885c-.435-3.919.33-7.91 2.36-11.29a18.052 18.052 0 015.91-6.015l1.748-1.094c-3.383-1.388-12.308-4.211-19.41-4.205z"
      fill="url(#paint1_linear_14209_45184)"
    />
    <Defs>
      <LinearGradient
        id="paint0_linear_14209_45184"
        x1={43.6817}
        y1={45.2117}
        x2={83.9534}
        y2={81.435}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0.46} stopColor="#0F893D" />
        <Stop offset={0.88} stopColor="#0F893D" stopOpacity={0.5} />
        <Stop offset={1} stopColor="#A4DB57" />
      </LinearGradient>
      <LinearGradient
        id="paint1_linear_14209_45184"
        x1={11.2018}
        y1={28.0534}
        x2={83.4352}
        y2={88.5034}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset={0.375} stopColor="#022649" />
        <Stop offset={0.705} stopColor="#4588FD" />
        <Stop offset={0.96} stopColor="#4588FD" />
      </LinearGradient>
    </Defs>
  </Svg>
);
export default GrpReferralRefive;
